import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cff6e600&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cff6e600')) {
      api.createRecord('cff6e600', component.options)
    } else {
      api.reload('cff6e600', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cff6e600&", function () {
      api.rerender('cff6e600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/monitoring/index.vue"
export default component.exports